import { RECS, SEARCH, SERVICE_TOGGLE_PARAMS, VISUAL_RECS, VISUAL_SEARCH } from 'util/appUtils';
import { buildSidebar } from './sidebarBuilder';
import { resolveLinks } from './sidebarUtils';

export function pruneUnavailableMenu(item) {
  if (!item || item.disabled) return null;
  if (!Array.isArray(item.children)) return item;

  const children = item.children
    .map(pruneUnavailableMenu)
    .filter(Boolean);
  if (children.length === 0) return null;
  return { ...item, children };
}

export function buildMenuData(
  shopId,
  settings,
  onboarding,
  searchExperience,
  capabilities = {},
  productId = null,
) {
  const isLoaded = shopId && settings?.isFetched && settings.platformSettings?.isFetched;
  if (!isLoaded) return undefined;

  const isEnabled = (appId) => {
    const paramName = SERVICE_TOGGLE_PARAMS[appId];
    return paramName && settings[paramName];
  };

  const experimentIsDisabled = () => {
    if (settings && settings.experiment) return !settings.experiment.enabled;
    return true;
  };

  const searchEnabled = isEnabled(SEARCH);
  const visualSearchEnabled = isEnabled(VISUAL_SEARCH);
  const recsEnabled = isEnabled(RECS);
  const visualRecsEnabled = isEnabled(VISUAL_RECS);

  const anySearchEnabled = searchEnabled || visualSearchEnabled;
  const anyRecsEnabled = recsEnabled || visualRecsEnabled;
  const hasConfiguredRecommendations = Boolean(
    visualRecsEnabled
    || (recsEnabled && Array.isArray(settings?.recs?.widgets) && settings.recs.widgets.length > 0),
  );
  const { platformSettings } = settings;

  // Extract views from search experience config (production mode)
  const searchViews = searchExperience?.config?.search?.views || {};
  const availableViews = Object.keys(searchViews);
  const searchMode = searchExperience?.config?.search?.searchExperience || null;

  const sidebar = buildSidebar({
    shopId,
    onboarding,
    searchEnabled,
    recsEnabled,
    anySearchEnabled,
    anyRecsEnabled,
    isLoaded,
    experimentIsDisabled,
    platformSettings,
    availableViews,
    searchMode,
    capabilities,
    productId: productId || 'plugin',
    interfaceManagedExternally: productId === 'cloud' && settings?.platform === 'manual',
  });

  const sideBarData = resolveLinks(sidebar, shopId);
  const cloudSearch = productId === 'cloud'
    ? pruneUnavailableMenu(sideBarData.pluginAdmin)
    : null;
  const cloudSections = [
    cloudSearch,
    hasConfiguredRecommendations ? pruneUnavailableMenu(sideBarData.recs) : null,
    pruneUnavailableMenu(sideBarData.store),
  ].filter(Boolean);
  return {
    full: productId === 'cloud'
      ? cloudSections
      : [].concat(
        sideBarData.search,
        sideBarData.recs,
        sideBarData.store,
        // sideBarData.account - hidden from vertical menu, moved to SidebarFooter
      ),
    cloudSearch,
    ...sideBarData,
  };
}
